import RequiredPasswordChangeForm from "@/features/auth/required-password-change/components/RequiredPasswordChangeForm";

export default function RequiredPasswordChangePage() {
  return <RequiredPasswordChangeForm />;
}
